import React from "react";
import "./HSEBlock.css";

function HSEBlock({ smallTitle, title, description, image, checkpoints }) {
  return (
    <section className="block block10">

      <div className="block10-content">

        <div className="block10-left">
          {image && <img src={image} alt="HSE" />}
        </div>

        <div className="block10-right">
          <h4 className="block10-small-title">{smallTitle || ''}</h4>
          <h2 className="block10-title">{title || ''}</h2>
          <p className="block10-description">{description || ''}</p>

          <div className="block10-points">
            {(checkpoints || []).map((checkpoint, index) => (
              <div key={index} className="point">✔ {checkpoint}</div>
            ))}
          </div>
        </div>

      </div>

    </section>
  );
}

export default HSEBlock;
